import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { AgreementListService } from '@services/agreement/agreement-list.service';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-renew-dialog',
  templateUrl: './renew-dialog.component.html',
  styleUrls: ['./renew-dialog.component.scss'],
})
export class RenewDialogComponent implements OnInit {
  newEffectiveDate: Date = new Date();
  effDateIsValid: boolean = true;
  effDateErrorMsg: string;

  newRenegDate: Date = new Date();
  renegDateIsValid: boolean = true;
  renegDateErrorMsg: string;

  newExpiryDate: Date;
  expDateIsValid: boolean = true;
  expDateErrorMsg: string;

  constructor(
    public dialogRef: MatDialogRef<RenewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private agreementListService: AgreementListService
  ) {}

  ngOnInit() {
    const previousRenegDate = this.data.renegDate ?? this.data.expiryDate;

    this.newEffectiveDate = new Date(previousRenegDate.getTime());
    this.newEffectiveDate.setDate(this.newEffectiveDate.getDate() + 1); // Add 1 day

    this.newRenegDate = new Date(this.newEffectiveDate.getTime());
    this.newRenegDate.setFullYear(this.newRenegDate.getFullYear() + 1); // Add 1 year
    this.newRenegDate.setDate(this.newRenegDate.getDate() - 1); // Subtract 1 day
  }

  onEffectiveDateChange(event, model: NgModel) {
    let effDateValidation = this.agreementListService.validateEffectiveDate(event);

    this.effDateIsValid = effDateValidation.isValid;
    model.control.setErrors({ customError: !this.effDateIsValid });
    this.effDateErrorMsg = effDateValidation.errorMsg;
  }

  onRenegDateChange(event, model: NgModel) {
    let renegDateValidation = this.agreementListService.validateRenegotiateDate(
      event,
      new Date(this.newEffectiveDate),
      new Date(this.newExpiryDate)
    );
    this.renegDateIsValid = renegDateValidation.isValid;
    model.control.setErrors({ customError: !this.renegDateIsValid });
    this.renegDateErrorMsg = renegDateValidation.errorMsg;
  }

  onExpiryDateChange(event, model: NgModel) {
    let expDateValidation = this.agreementListService.validateExpirationDate(
      event,
      this.newEffectiveDate.toDateString(),
      this.newRenegDate.toDateString()
    );

    this.expDateIsValid = expDateValidation.isValid;
    model.control.setErrors({ customError: !this.expDateIsValid });
    this.expDateErrorMsg = expDateValidation.errorMsg;
  }

  getRenewData() {
    return {
      newEffectiveDate: this.newEffectiveDate,
      newRenegDate: this.newRenegDate,
      newExpiryDate: this.newExpiryDate,
    };
  }

  isSaveDisabled(): boolean {
    return (
      !this.newEffectiveDate ||
      !this.newRenegDate ||
      !this.effDateIsValid ||
      !this.renegDateIsValid ||
      !this.expDateIsValid
    );
  }
}
